export default "/images/vendor/flag-icons/flags/4x3/mx.svg?6b5b07b466de97533812012c87d0facb";